import React from "react";
import { Button } from "../../components/ui/button";
import { Checkbox } from "../../components/ui/checkbox";
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogFooter,
  DialogHeader,
  DialogTitle,
} from "../../components/ui/dialog";
import { Input } from "../../components/ui/input";
import { Label } from "../../components/ui/label";
import { Textarea } from "../../components/ui/textarea";

export const TaskDialog = ({
  title,
  description,
  children,
  onClose,
  className = "",
}) => (
  <Dialog open onOpenChange={(open) => !open && onClose?.()}>
    <DialogContent className={className}>
      <DialogHeader>
        <DialogTitle>{title}</DialogTitle>
        {description ? (
          <DialogDescription>{description}</DialogDescription>
        ) : null}
      </DialogHeader>
      {children}
    </DialogContent>
  </Dialog>
);

export const TaskMessage = ({ tone = "error", children }) => {
  if (!children) return null;

  const className =
    tone === "success"
      ? "rounded-md border border-tone-success-border bg-tone-success-surface px-3 py-2 text-sm text-tone-success-foreground"
      : "rounded-md border border-destructive/30 bg-destructive/10 px-3 py-2 text-sm text-destructive";

  return <div className={className}>{children}</div>;
};

export const TaskField = ({ id, label, children, className = "" }) => (
  <div className={`space-y-2 ${className}`}>
    <Label htmlFor={id}>{label}</Label>
    {children}
  </div>
);

export const TaskTextInput = ({ id, label, className = "", ...props }) => (
  <TaskField id={id} label={label} className={className}>
    <Input id={id} {...props} />
  </TaskField>
);

export const TaskTextArea = ({ id, label, className = "", ...props }) => (
  <TaskField id={id} label={label} className={className}>
    <Textarea id={id} {...props} />
  </TaskField>
);

export const TaskCheckbox = ({
  label,
  checked,
  onCheckedChange,
  className = "",
}) => (
  <label
    className={`flex items-center gap-3 rounded-md border bg-muted/20 p-3 ${className}`}
  >
    <Checkbox checked={checked} onCheckedChange={onCheckedChange} />
    <span className="text-sm font-medium">{label}</span>
  </label>
);

export const TaskDialogActions = ({
  onCancel,
  onSubmit = undefined,
  submitLabel = "Save",
  cancelLabel = "Cancel",
  disabled = false,
  submitType = "button",
}: any) => (
  <DialogFooter>
    <Button
      type="button"
      variant="outline"
      onClick={onCancel}
      disabled={disabled}
    >
      {cancelLabel}
    </Button>
    <Button type={submitType} onClick={onSubmit} disabled={disabled}>
      {submitLabel}
    </Button>
  </DialogFooter>
);
